export const UI_OPTION_KEYS = {
  SEARCH_TYPE: 'SEARCH_TYPE'
};
